export const BookingOptionParts = [
  { id: 'venue', name: $localize `Venue` },
  { id: 'bookingDates', name: $localize `Dates` },
  { id: 'bookingWindow', name: $localize `Booking window` },
  { id: 'capacities', name: $localize `Capacities` },
  { id: 'pricing', name: $localize `Pricing` },
  { id: 'form', name: $localize `Form` },
  { id: 'eligibility', name: $localize `Eligibility` },
  { id: 'bundle', name: $localize `Bundle` },
];
